import React from "react";
import classes from "../../assets/styles/Pages/Help/Help.module.css";
import { FaHandsHelping } from "react-icons/fa";
import { BiPhone } from "react-icons/bi";
import { AiFillMessage } from "react-icons/ai";
import { BsPlayCircle } from "react-icons/bs";
import { ReactComponent as AboutIcon } from "../../assets/images/icon-white.svg";
import { IoDocumentTextSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import { BsChevronRight } from "react-icons/bs";
import helpimage from "../../assets/images/help/help_home.png";
import AboutUsIcon from "../../assets/images/help/About-Us.svg";
import ContactIcon from "../../assets/images/help/Contact.svg";
import TutorialsIcon from "../../assets/images/help/Tutorials.svg";
import FaqIcon from "../../assets/images/help/Faq.svg";
import TermsIcon from "../../assets/images/help/TermsConditions.svg";
import PrivacyPolicyIcon from "../../assets/images/help/PrivacyPolicy.svg";
import ExchangeIcon from "../../assets/images/help/Excahnge.svg";
import intellectualIcon from "../../assets/images/help/Intellectual.svg";

const Help = () => {
  const helpLinks = [
    {
      to: "/help/aboutus",
      icon: <img src={AboutUsIcon} alt="FAQ Icon" className="custom-icon" />,
      title: "About Us",
      desc: "About Us",
    },
    {
      to: "/help/helpContactUs",
      icon: <img src={ContactIcon} alt="FAQ Icon" className="custom-icon" />,
      title: "Contact Us",
      desc: "Contact Us",
    },
    {
      to: "/help/helpTutorial",
      icon: <img src={TutorialsIcon} alt="FAQ Icon" className="custom-icon" />,
      title: "Tutorials",
      desc: "Tutorials",
    },
    {
      to: "/help/helpFaqs",
      icon: <img src={FaqIcon} alt="FAQ Icon" className="custom-icon" />,
      title: "FAQ's",
      desc: "Frequently Asked Questions",
    },
    {
      to: "/help/termsandcondition",
      icon: <img src={TermsIcon} alt="FAQ Icon" className="custom-icon" />,
      title: "Terms & Conditions",
      desc: "Terms & Condition",
    },
    {
      to: "/help/privacyandpolicy",
      icon: (
        <img src={PrivacyPolicyIcon} alt="FAQ Icon" className="custom-icon" />
      ),
      title: "Privacy & Policy",
      desc: "Privacy & Policy",
    },
    {
      to: "/help/exchangepolicy",
      icon: <img src={ExchangeIcon} alt="FAQ Icon" className="custom-icon" />,
      title: "Exchange Policy",
      desc: "Exchange Policy",
    },
    {
      to: "/help/intellectualproperty",
      icon: (
        <img src={intellectualIcon} alt="FAQ Icon" className="custom-icon" />
      ),
      title: "Intellectual Property",
      desc: "Intellectual Property",
    },
  ];

  return (
    <>
      <div className="">
        <div className="heading">
          {/* Help top left section */}
          <h1 className="mb-0">Help Center</h1>
          <p className="">
            How can we help you? Explore our Help section for additional
            information, tutorials, FAQs, and policies.
          </p>

          {/* <div className={classes.btnsWrapper}>
            <Link to="/help/termsandcondition">
              <button>Terms & Condition</button>
            </Link>
            <Link to="/help/helpContactUs">
              <button>Contact Us</button>
            </Link>
          </div> */}

          {/*Right Section Image */}
          {/* <div className="col-sm-6">
              <img src={helpimage} alt="" className="helpImage" />
            </div> */}
        </div>

        {/* Second Section */}

        <div className="mt-5">
          <div className="row gy-4">
            {helpLinks.map((item, idx) => (
              <div key={idx} className="col-12 col-sm-6 col-lg-4">
                <Link to={item.to} className="text-decoration-none">
                  <div className="cardWrapper d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                      <div className="mainIcon">{item.icon}</div>
                      <div className="heading">
                        <h3 className="mb-1">{item.title}</h3>
                        <p className="mb-0">{item.desc}</p>
                      </div>
                    </div>
                    <BsChevronRight className="" />
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Help;
